import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

/*
 * Installs the rotating API-key interceptor globally.
 * Keep this import before App.
 */
import "./api/rotatingApiKey";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Measure application performance when required.
reportWebVitals();
